import React, { useRef, useEffect, useState } from "react";
import DehazeIcon from "@mui/icons-material/Dehaze";
import {
     Chart,
     ChartSeries,
     ChartLegend,
     ChartSeriesItem,
     ChartCategoryAxis,
     ChartCategoryAxisItem,
} from "@progress/kendo-react-charts";
import { useSelector,useDispatch } from "react-redux";
import UiSelect from "../../../_uiComponents/common/form/UiSelectDefault";
import UiDateRangePicker from "../../../_uiMocks/_uiComponents/UiDateRangePicker";
import {
     timeFormatUtcToLocal,
     getObjectFromArray,
     getDateRangeString,
     showCustomLoading,
} from "../../../../_helpers/support.services";
import ExportToExcelWithApi from "../../../_uiComponents/common/ExportToExcelWithApi";
import { dashboardConstants } from "../../../../_redux/_constants";
import { InnerLoader } from "../../../_uiComponents/common/UiLoadingSpinner";
import  {getCampaignPageViewSummaryDownloadRequest} from "../../../../_redux/_actions"


export default function CampaignPageViewSummary(props) {
     const actionDispatch = useDispatch();
     const [startDate, setStartDate] = useState(null);
     const [endDate, setEndDate] = useState(null);
     const [jobRoleId, setJobRoleId] = useState("");
     const [areaId, setAreaId] = useState("");
     const [exportData, setExportData] = useState(null);

     const downloadFileName = useRef(null);

     const { dashBoardPageViewSummary, areaList, loader,dashboardCampaignPageViewSummaryDownload  } = useSelector((state) => {
          return {
               dashBoardPageViewSummary:
                    state.dashboard.dashBoardPageViewSummary,
               areaList: state.dashboard.areaList,
               loader: state.loading,
               dashboardCampaignPageViewSummaryDownload:state.dashboard.dashboardCampaignPageViewSummaryDownload
          };
     });

     const getData = (
          startDate = null,
          endDate = null,
          jobRoleId = null,
          areaId = null,
     ) => {
          downloadFileName.current =
               "campaign_page_view_summary_" +
               getObjectFromArray(
                    props.applicationId,
                    "value",
                    dashboardConstants.userTypes,
               ).label +
               "_job_role_" +
               getObjectFromArray(jobRoleId, "value", props.jobRolesOptions)
                    .label +
               "_date_" +
               getDateRangeString(startDate, endDate) +
               "_area_" +
               getObjectFromArray(areaId, "value", [
                    {
                         value: "0",
                         label: "All",
                    },
                    ...areaList.map(function (item) {
                         return {
                              label: item.area,
                              value: item.area,
                         };
                    }),
               ]).label;

          props.getData(
               startDate,
               endDate,
               jobRoleId,
               areaId,
               props.applicationId,
          );
     };

     useEffect(
          function () {
               getData(startDate, endDate, jobRoleId, areaId);
          },
          [props.applicationId],
     );

       useEffect(()=>{
               setExportData(dashboardCampaignPageViewSummaryDownload)
          },[dashboardCampaignPageViewSummaryDownload])
     
          const fetchDataForExport = async (onDownloadComplete) => {
               try {
               actionDispatch(getCampaignPageViewSummaryDownloadRequest({
                         downloadType:"campaignpageview",
                         startDate,
                         endDate,
                         jobRoleId,
                         areaId,
                         applicationId: props.applicationId
                    }));
               } catch (error) {
                    onDownloadComplete(false);
                    console.error("Error fetching data for export:", error);
               }
          };

     return (
          <>
               <div className="sba-chart-top-section sba-line-chart-section">
                    {showCustomLoading(
                         [dashboardConstants.DASHBOARD_GET_CAMPAIGN_PAGE_VIEW_SUMMARY_REQUEST],
                         loader.pendingRequests
                    ) && <InnerLoader/>}
                    <h5>Campaign Page View Summary</h5>
                    <ExportToExcelWithApi 
                              name={downloadFileName.current}
                              data={exportData}
                              onDownloadClick={(onDownloadComplete) => fetchDataForExport(onDownloadComplete)}
                         />
                    {/* <ExportToExcel
                         name={downloadFileName.current}
                         data={dashBoardPageViewSummary?.exelFormat}
                    /> */}
                    <div className="sba-chart-top-select-col">
                         <UiSelect
                              options={[
                                   {
                                        value: "0",
                                        label: "All",
                                   },
                                   ...areaList.map(function (item) {
                                        return {
                                             label: item.area,
                                             value: item.area,
                                        };
                                   }),
                              ]}
                              label="Area"
                              value={areaId}
                              defaultValue={0}
                              handleChange={(value) => {
                                   getData(
                                        startDate,
                                        endDate,
                                        jobRoleId,
                                        value,
                                   );
                                   setAreaId(value);
                              }}
                         />
                    </div>
                    <div className="sba-chart-top-select-col">
                         <UiSelect
                              options={props.jobRolesOptions}
                              label="Job Role"
                              value={jobRoleId}
                              handleChange={(value) => {
                                   getData(startDate, endDate, value, areaId);
                                   setJobRoleId(value);
                              }}
                         />
                    </div>
                    <div className="sba-chart-top-range-picker">
                         <UiDateRangePicker
                              onChange={(value) => {
                                   if (value[0] && value[1]) {
                                        const startDate = timeFormatUtcToLocal(
                                             value[0],
                                        );
                                        const endDate = timeFormatUtcToLocal(
                                             value[1],
                                        );
                                        setStartDate(startDate);
                                        setEndDate(endDate);

                                        getData(
                                             startDate,
                                             endDate,
                                             jobRoleId,
                                             areaId,
                                        );
                                   } else {
                                        if (!value[0] && !value[1]) {
                                             setStartDate(null);
                                             setEndDate(null);
                                             getData(
                                                  null,
                                                  null,
                                                  jobRoleId,
                                                  areaId,
                                             );
                                        }
                                   }
                              }}
                         />
                    </div>
                    <div className="sba-drag-handle">
                         <DehazeIcon />
                    </div>
               </div>
               <div className="expand-chart">
                    <Chart transitions={false}>
                         <ChartLegend
                              position="bottom"
                              orientation="horizontal"
                         />

                         <ChartCategoryAxis>
                              <ChartCategoryAxisItem
                                   labels={{
                                        rotation: "auto",
                                   }}
                                   categories={
                                        dashBoardPageViewSummary?.categories
                                   }
                              />
                         </ChartCategoryAxis>

                         <ChartSeries>
                              {dashBoardPageViewSummary?.chartDataList?.map(
                                   (item, idx) => (
                                        <ChartSeriesItem
                                             name={item.name}
                                             type="line"
                                             data={item.values}
                                             tooltip={{ visible: true }}
                                        />
                                   ),
                              )}
                         </ChartSeries>
                    </Chart>
               </div>
          </>
     );
}
